import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../router/all_routes";
import AXIOSCONFIGMETHOD from "../../../Axios/axiosConfigMethod";
import { webServiceUrl } from "../../../core/api_utils/webserviceUrl";
import { useAuth } from "../../../core/common/context/AuthContext";
import { LoadingButton } from "../../../core/common/custom-loading/Loading";
import { toast } from "react-toastify";
import {
  setLocalStorageOrganization,
  setLocalStorageProperty,
} from "../../../utils/localStorageItem";
import { useApi } from "../../../hooks/useAPI";

type LoginDataType = {
  email: string;
  password: string;
};

type ErrorType = {
  email?: string;
  password?: string;
  role_id?: string;
  error?: string;
};

type PasswordField = "password";

const initialLoginData: LoginDataType = {
  email: "",
  password: "",
  // email: "super@admin.com",
  // password: "admin@12345",
};

const Login = () => {
  const [passwordVisibility, setPasswordVisibility] = useState({
    password: false,
  });
  // const [loginData, setLoginData] = useState<LoginDataType>({
  //   email: "",
  //   password: "",
  // });
  const [loginData, setLoginData] = useState<LoginDataType>(initialLoginData);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [errors, setErrors] = useState<ErrorType>({});
  const { setToken, setIsAuthenticated } = useAuth();

  const routes = all_routes;
  const navigation = useNavigate();

  const togglePasswordVisibility = (field: PasswordField) => {
    setPasswordVisibility((prevState) => ({
      ...prevState,
      [field]: !prevState[field],
    }));
  };

  const {
    // data: loginData,
    loading: loginLoading,
    callApi: login,
  } = useApi<any>(webServiceUrl.superAdminLogin, {
    method: "POST",
    autoCall: false,
    dependencies: [],
  });

  // const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
  //   e.preventDefault();
  //   const validate = formValidation();
  //   if (!validate) return;
  //   setIsSubmitting(true);
  //   try {
  //     const resp = await login({
  //       admin_email: loginData?.email,
  //       admin_password: loginData?.password,
  //     });

  //     if (resp?.success) {
  //       // console.log(resp.token);
  //       localStorage.setItem("token", resp?.token);
  //       setToken(resp?.token);
  //       setTimeout(() => setLoginData(initialLoginData), 1000);
  //       navigation(routes.adminDashboard);

  //       setLocalStorageOrganization({ id: "", name: "" });
  //       setLocalStorageProperty({ id: "", name: "" });
  //     }
  //   } catch (error: any) {
  //     // console.log(error);
  //     console.error("error while login:", error);
  //     toast.error(error?.response?.data?.message || "Login failed!");
  //     setIsSubmitting(false);
  //   }
  // };

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
  e.preventDefault();

  const validate = formValidation();
  if (!validate) return;

  setIsSubmitting(true);

  try {
    const resp = await login({
      admin_email: loginData?.email,
      admin_password: loginData?.password,
    });

    if (!resp) {
      toast.error("Login request timed out. The API server is unreachable.");
      return;
    }

    if (resp?.success && resp?.token) {
      localStorage.setItem("token", resp?.token);
      setToken(resp?.token);
      setIsAuthenticated(true);

      setTimeout(() => {
        setLoginData(initialLoginData);
      }, 1000);

      navigation(routes.adminDashboard);

      setLocalStorageOrganization({ id: "", name: "" });
      setLocalStorageProperty({ id: "", name: "" });
    } else {
      toast.error(resp?.message || "Login failed!");
    }
  } catch (error: any) {
    console.error("LOGIN ERROR:", error);
    console.error("RESPONSE:", error?.response?.data);

    toast.error(
      error?.userMessage ||
        error?.response?.data?.message ||
        (error?.code === "ECONNABORTED"
          ? "Login request timed out. Check that the API is reachable."
          : "Login failed!"),
    );
  } finally {
    setIsSubmitting(false);
  }
};

  const formValidation = () => {
    const { email, password } = loginData;
    const newError: ErrorType = {};

    if (!email || !email.trim()) {
      newError.email = "email is required!";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      newError.email = "Invalid email format!";
    }
    if (!password) {
      newError.password = "password is required!";
    }
    setErrors(newError);
    return Object.keys(newError).length === 0;
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked, type } = e.target;
    setErrors({});
    setLoginData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // console.log(token);
  // console.log(errors)
  // console.log(loginData);

  return (
    <div className="container loginPage" style={{ width: "100%" }}>
      <div className="h-100 w-100 d-flex flex-column">
        <div className="flex-grow-1 w-100 d-flex justify-content-center align-items-center ">
          <form
            onSubmit={handleLogin}
            className=" card p-0 mb-0"
            style={{ maxWidth: "500px", width: "90%" }}
          >
            <div className=" d-flex flex-column justify-content-between gap-3 pt-3 pt-md-5 pb-4 px-4 px-md-4">
              <div
                className=" mx-auto mb-0 text-center"
                style={{ width: "9rem" }}
              >
                <ImageWithBasePath
                  src="assets/Nestfin_logo.png"
                  className="img-fluid"
                  alt="Nesfin-Logo"
                />
              </div>
              <div className="pt-0 mt-0 d-flex flex-column justify-content-center ">
                <div className="text-center mb-4">
                  <h2 className="mb-2">Login</h2>
                  <p className="mb-0">Please enter your details to login</p>
                </div>
                <div className="mb-3 col-12 col-sm-8 col-md-12 mx-auto">
                  <label className="form-label">Email Address</label>
                  <div className="input-group">
                    <input
                      type="text"
                      name="email"
                      placeholder="joe@gmail.com"
                      value={loginData?.email}
                      onChange={handleChange}
                      className="form-control border-end-0"
                      disabled={isSubmitting}
                    />
                    <span className="input-group-text border-start-0">
                      <i className="ti ti-mail" />
                    </span>
                  </div>
                  {errors?.email && (
                    <p className="text-danger mb-0 p-0 pt-2  px-1">
                      {errors?.email}
                    </p>
                  )}
                </div>
                <div className="mb-3 col-12 col-sm-8 col-md-12 mx-auto">
                  <label className="form-label">Password</label>
                  <div className="pass-group">
                    <input
                      type={passwordVisibility.password ? "text" : "password"}
                      name="password"
                      placeholder="Enter your password"
                      value={loginData?.password}
                      onChange={handleChange}
                      className="pass-input form-control"
                      disabled={isSubmitting}
                    />
                    <span
                      className={`ti toggle-passwords ${
                        passwordVisibility.password ? "ti-eye" : "ti-eye-off"
                      }`}
                      onClick={() => togglePasswordVisibility("password")}
                    ></span>
                  </div>
                  {errors?.password && (
                    <p className="text-danger mb-0 p-0 pt-2  px-1">
                      {errors?.password}
                    </p>
                  )}
                </div>
                <div className="mb-3 mt-2 col-12 col-sm-8 col-md-12 mx-auto">
                  <button
                    type="submit"
                    className="btn btn-primary w-100 py-2 fs-15 d-flex align-items-center justify-content-center gap-2"
                    disabled={isSubmitting}
                  >
                    Sign In
                    {isSubmitting && (
                      <div className="d-inline">
                        <LoadingButton />
                      </div>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="footer mt-2 d-sm-fle text-center align-items-center justify-content-center border-to bg-whit pt-3 pt-md-0 pb-3">
          <p className="mb-0 mt-0 ">
            © {new Date().getFullYear()} Nestfin. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
